<template>
  <div>
    <div
        class="flex flex-col items-center pb-5 xs:px-[20px] sm:px-[70px] md:px-[137px] lg:px-[172px] max-w-[1080px] mx-auto text-white">
      <p
          class="xs:text-[35px] sm:text-[35px] md:text-[33px] lg:text-[76px] text-center font-extrabold tracking-[-1.52px] xs:leading-[48px] sm:leading-[48px] md:leading-[48px] lg:leading-normal animate__animated animate__zoomIn"
      >
        Please select a person
      </p>

      <div class="relative mt-8">
        <select
            v-model="selectedSales"
            class="block w-full p-3 pr-12 text-black rounded-lg appearance-none"
        >
          <option disabled value="">Select a name</option>
          <option
              v-for="option in salesOptions"
              :key="option.value"
              :value="option.value"
          >
            {{ option.label }}
          </option>
        </select>

        <div class="pointer-events-none absolute inset-y-0 right-3 flex items-center">
          <svg class="w-5 h-5 text-gray-700" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd"
                  d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.08 1.04l-4.25 4.25a.75.75 0 01-1.08 0L5.21 8.27a.75.75 0 01.02-1.06z"
                  clip-rule="evenodd"/>
          </svg>
        </div>
      </div>


      <button
          @click="goToNextStep"
          :disabled="!selectedSales"
          class="xs:text-[19px] sm:text-[26px] md:text-[26px] lg:text-[42px] font-extrabold bg-[#E69F29] px-[15%] py-[12px] md:px-[90px] md:py-[12px] lg:px-[166px] lg:py-[25px] rounded-[53px] tracking-[-0.84px] mt-[30px] lg:mt-[80px] disabled:opacity-50"
      >
        START
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "Step0Page",
  data() {
    return {
      selectedSales: "",
      salesOptions: [
        {value: "danai", label: "Danai Volika"},
        {value: "elena", label: "Elena Rovythaki"},
        {value: "christos", label: "Christos Maltis"},
        {value: "ioanna", label: "Ioanna Mantouvalou"},
        {value: "ioannam", label: "Ioanna Michailidou"},
        {value: "michaella", label: "Michaella Agrapidi"},
        {value: "natassa", label: "Natassa Piotogiannaki"},
        {value: "stavrianna", label: "Stavrianna Choutridi"},
        {value: "other", label: "Other"},
      ]
    };
  },
  methods: {
    goToNextStep() {
      if (!this.selectedSales) return;

      const url = new URL(window.location.origin + window.location.pathname);
      url.searchParams.set('sales', this.selectedSales);
      window.history.replaceState({}, '', url);


      this.$emit('next-step');
    }
  }
};
</script>
